import * as yup from 'yup';
import { declaracao } from './utils/rulesByKey';

export const BPDSchema = yup.object({
  ...declaracao,
});

export const BPDInitialValues = {
  declaracao: false,
};
